import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';

export const InitialLoginState = {
    company_id: null,
    user_name: null,
    password: null
};

export const LoginSchema = Yup.object().shape({
    company_id: Yup.number().required(),
    user_name: Yup.string().required(),
    password: Yup.string().required(),
});

export const LoginFormFields = [
    { name: "company_id", title: "Company", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "user_name", title: "User Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "password", title: "Password", required: true, type: VALUE_TYPES.PASSWORD }
];
